export default class MemberOfferingBooking {
    static fromData(data) {
        if (!data) {
            return;
        }

        const memberOfferingBooking = new MemberOfferingBooking();
        memberOfferingBooking.id = data.id;
        memberOfferingBooking.bookedAt = data.bookedAt;
        memberOfferingBooking.canceledAt = data.canceledAt;
        memberOfferingBooking.canceledByClubAt = data.canceledByClubAt;
        memberOfferingBooking.isCanceled = data.isCanceled;
        memberOfferingBooking.offering = {
            id: data.offering.id,
            title: data.offering.title,
            customId: data.offering.customId,
            offeringCategory: {
                name: data.offering.offeringCategory.name,
                backgroundColor: data.offering.offeringCategory.backgroundColor,
            },
        };
        memberOfferingBooking.appointmentSeriesId = data.appointmentSeriesId;
        memberOfferingBooking.start = data.start;
        memberOfferingBooking.bookedByMember = {
            id: data.bookedByMember.id,
            fullName: data.bookedByMember.fullName,
        };
        memberOfferingBooking.invoiceMember = {
            id: data.invoiceMember.id,
            fullName: data.invoiceMember.fullName,
        };
        memberOfferingBooking.isOfferingBookingMode = data.isOfferingBookingMode;
        memberOfferingBooking.isStartInPast = data.isStartInPast;
        memberOfferingBooking.attendeeStatus = data.attendeeStatus;

        return memberOfferingBooking;
    }
}
